/**
 * EmptyState — bee-mascot-driven empty states for My Writing.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { MascotContainer, Button } from '@/components/site/primitives';
import { fadeUp } from '@/lib/motion';
import { EMPTY_STATE_MESSAGES } from './constants';

import beeScribble from '@/assets/bee-scribble.png';
import beeStand from '@/assets/bee-stand.png';
import beeBack from '@/assets/bee-back.png';

const MASCOTS = {
  noStories: beeScribble,
  inProgress: beeStand,
  draft: beeScribble,
  published: beeStand,
  archived: beeBack,
  search: beeBack,
};

export default function EmptyState({ type = 'noStories', onCTAClick, size = 'md', className = '' }) {
  const message = EMPTY_STATE_MESSAGES[type] ?? EMPTY_STATE_MESSAGES.noStories;
  const compact = size === 'sm';

  return (
    <div className={`${compact ? 'flex items-center justify-center py-10' : 'flex min-h-[320px] items-center justify-center py-14'} ${className}`}>
      <motion.div variants={fadeUp} initial="hidden" animate="show" className="mx-auto max-w-sm text-center">
        <MascotContainer src={MASCOTS[type] ?? beeScribble} alt="" className={compact ? 'mx-auto h-20 w-20' : 'mx-auto h-28 w-28'} />
        <h2 className="mt-4 font-display text-lg font-semibold text-ink">{message.heading}</h2>
        <p className="mt-2 text-sm leading-relaxed text-subtle">{message.subheading}</p>
        {onCTAClick && message.cta && (
          <Button variant="primary" icon={false} onClick={onCTAClick} className="mt-5" data-testid="my-writing-empty-cta">
            {message.cta}
          </Button>
        )}
      </motion.div>
    </div>
  );
}
